module.exports = __webpack_public_path__ + "bc248d5cca94a748f6f615719dd01fe4.png";